import { Button } from "@/components/ui/button"
import { Plus } from "lucide-react"

interface EmptyListProps {
  text: string
  addText: string
  onClick: () => void
  showAdd: boolean
}

const EmptyList = ({ text, addText, onClick, showAdd }: EmptyListProps) => (
  <div className="flex flex-col items-center justify-center gap-5" data-testid="empty-list">
    <p className="max-w-[500px] text-center text-sm text-muted-foreground">{text}</p>
    {showAdd ? (
      <Button onClick={onClick} data-testid="empty-list-action">
        <Plus className="mr-2 h-4 w-4" />
        {addText}
      </Button>
    ) : null}
  </div>
)

export default EmptyList
